var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-option-group',_vm._g(_vm._b({},'el-option-group',_vm.$attrs,false),_vm.inputListeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }